import styled from "styled-components";

const OverlayToolbar = styled.div`
  background: ${p => p.theme.colors.white};
  border-bottom: 1px solid ${p => p.theme.colors.grey100};
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 101;
`;

export default OverlayToolbar;
